/**
 * Board page manager — hero + alternating Executive/Officer role blocks.
 * See boardData.js for the content model; member photos/names and role
 * descriptions are placeholders there until real content is supplied.
 */
import "./BoardPage.css";
import Hero from "./Hero";
import SectionHeader from "./SectionHeader";
import RoleBlock from "./RoleBlock";
import Lightbox from "./Lightbox";
import { LightboxProvider } from "./LightboxContext";
import { execRoles, officerCommittees } from "./boardData";

function BoardPage() {
  return (
    <LightboxProvider>
      <div className="board-page">
        <Hero />

        <section className="board-section board-section--exec">
          <div className="board-section-content">
            <SectionHeader variant="exec">Executive Board</SectionHeader>
            {execRoles.map((role, i) => (
              <RoleBlock key={role.id} role={role} variant="exec" reverse={i % 2 === 1} />
            ))}
          </div>
        </section>

        <section className="board-section board-section--officer">
          <div className="board-section-content">
            <SectionHeader variant="officer">Officer Board</SectionHeader>
            {officerCommittees.map((role, i) => (
              <RoleBlock key={role.id} role={role} variant="officer" reverse={i % 2 === 1} />
            ))}
          </div>
        </section>

        <Lightbox />
      </div>
    </LightboxProvider>
  );
}

export default BoardPage;
